<template>
  <div class="container-fluid mt-4 px-1">
    <div class="row gx-3"> 
      <div class="col-md-4">
        <ranking-list-card
          :horizontal-break="false"
          :card="{
            title: '이벤트 데이터',
          }"
          :item="dataList"
        >
        </ranking-list-card>
      </div>


      <div class="col-md-4">
        <div class="card shadow-sm p-4 h-100">
              <div class="col-md-6">
                <h6 class="pb-4 mb-0">입력 데이터</h6>
              </div>
          <form @submit.prevent="submitEvent">

            <div class="mb-3">
              <label for="parentID" class="form-label">포장재 선택</label>
              <select v-model="form.parentID" class="form-select" id="parentID">
                <option value="">선택</option>
                <option v-for="item in boxList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>


            <div class="mb-3">
              <label for="epc" class="form-label">제품 목록</label>
              <multiselect id="multiselect" class="ms-urn" v-model="selectedUrns" :options="combinedListWithLabel" :multiple="true" :close-on-select="false" :clear-on-select="false"
                        select-label="추가" selected-label="선택" deselect-label="삭제"
                        :preserve-search="true" placeholder="제품 선택" label="labelWithUrn" track-by="urn" :preselect-first="true">
              <template #selection="{ values }">
                <span class="multiselect__single"
                      v-if="values.length">{{ values.length }} 개 선택</span>
              </template>
              </multiselect>
            </div>

            <!-- 스캔장소 (readPoint) -->
            <div class="mb-3">
              <label for="readPoint" class="form-label">스캔장소 (readPoint)</label>
              <select v-model="form.readPoint.manualURI" class="form-select" id="readPoint">
                <option value="">선택</option>
                <option v-for="item in readPointList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 입고장소 (bizLocation) -->
            <div class="mb-3">
              <label for="bizLocation" class="form-label">포장장소 (bizLocation)</label>
              <select v-model="form.bizLocation.manualURI" class="form-select" id="bizLocation">
                <option value="">선택</option>
                <option v-for="item in bizLocationList" :key="item.id" :value="item.urn">
                  {{ item.name + ' ( ' + item.urn + ' )'}}
                </option>
              </select>
            </div>

            <!-- 수량 -->
            <div class="mb-3">
              <label for="eventTime" class="form-label">이벤트 발생 시간</label>
              <input type="datetime-local" v-model="eventTimeTemp" class="form-control" id="eventTime" />
            </div>

            <!-- 등록 버튼 -->
            <div class="text-end">
              <button type="submit" class="btn btn-success">이벤트 등록</button>
            </div>
          </form>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card shadow-sm p-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">포장 제품</h6>
          </div>
          <div class="selected-list">
            <template v-if="selectedUrns.length">
            <ul class="list-unstyled mb-0">
              <li v-for="it in selectedUrns" :key="it.urn" class="sel-item">
                <div class="d-flex align-items-center justify-content-between">
                  <span class="prod-chip">{{ it.name }}</span>
                </div>
                <div class="urn-line" :title="it.urn">{{ it.urn }}</div>
              </li>
            </ul>
            </template>
            <div v-else class="empty-state">선택된 재료가 없습니다.</div>
          </div>
        </div>
      </div>
    </div>

    <EventListTable
      :eventList="recentEventList"
      :loading="loadingEvents"
      :minBodyHeight="300"
      emptyMessage="최근 이벤트가 없습니다."
    />

  </div>
</template>
<script>
import { fetchBizLocationData, fetchReadPointData, fetchProductData } from "../../api/common/initDataAPI";
import { pollEpcisEvent, saveBlockChain } from "@/api/common/blockchain.js";
import RankingListCard from "@/examples/Cards/RankingListCard.vue";
import Multiselect from 'vue-multiselect'
import EventListTable from "@/views/components/EventListTable.vue";
import api from '@/api/api';

export default {
  name: "EventPrc5",
  components: {
    RankingListCard,
    Multiselect,
    EventListTable,
  },
  inject: ['showLoading', 'hideLoading'],
  computed: {
    mfId() {
      return this.$store.getters['UserStore/getMfId'];
    },
    selectedNames() {
      return this.selectedUrns.map(opt => `${opt.name} (${opt.urn})`);
    },
    dataList() {
      return [{
        title: '이벤트타입',
        date: 'EventType',
        amount: 'AggregationEvent',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '액션',
        date: 'Action',
        amount: 'ADD',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '업무단계',
        date: 'bizStep',
        amount: 'PACKING',
        icon: 'fa-info',
        color: 'dark',
      },
      {
        title: '처리상태',
        date: 'Disposition',
        amount: 'IN_PROGRESS',
        icon: 'fa-info',
        color: 'dark',
      }
      ]
    },
    combinedListWithLabel() {
      return this.combinedList.map(item => ({
        ...item,
        labelWithUrn: `${item.name} (${item.urn})`
      }));
    },
  },
  watch: {
    'form.readPoint.manualURI'(urn) {
      const sel = this.readPointList.find(r => r.urn === urn);
      if (sel && sel.blId != null) {
        const blId = sel.blId;
        if(blId){
          const selBlId = this.bizLocationList.find(b => b.id === blId);
          if(selBlId) this.form.bizLocation.manualURI = selBlId.urn;
        }
      }
    }
  },
  data() {
    return {
      loadingEvents: true,
      epc: '',
      crtEventID: '',
      eventTimeTemp: '',
      form: {
        parentID: '',
        childEPCs: [],
        eventType: "AggregationEvent",
        action: 'ADD',
        businessStep: 'PACKING',
        disposition: 'IN_PROGRESS',
        eventTimeSelector: '',
        eventTime: {},
        quantity: '1',
        epcList: [],
        readpointselector: 'manually',
        readPoint: {
          gcpLength: null,
          manualURI: "",
        },
        businesslocationselector: "manually",
        bizLocation: {
          gcpLength: null,
          manualURI: "",
        },
        vocabularySyntax: 'URN',
        ordinaryEvent: true,
        RecordTimeOption: 'no',
        recordTimeType: 'SAME_AS_EVENT_TIME',
        PersistentDispositionType: null,
        PersistentDisposition: null,
        persistentDispositionCount: 0,
        persistentDispositionList: [],
        businessTransactionCount: 0,
        businessTransactionList: [],
        errorCorrectiveCount: 0,
        errorCorrectiveIdsList: [],
        eventID: false,
        eventIdType: 'UUID',
        hashAlgorithm: 'sha-256',
      },
      productList: [],
      combinedList: [],
      bizLocationList: [],
      readPointList: [],

      selectedUrns: [],
      boxList: [],
      
      recentEventList: [],
    }
  },
  async mounted() {
    this.eventTimeTemp = this.setDefaultTime();

    let now = new Date()
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset())
    now.setSeconds(now.getSeconds(), 0)
    now = now.toISOString().slice(0, -1)

    this.form.eventTime = {
      specificTime: now,
      fromTime: now,
      toTime: now,
      timeZoneOffset: '+09:00'
    }

    this.$store.state.DesignTestDataStore.eventType = "AggregationEvent";
    
    const [bizList, readList, prdList] = await Promise.all([
      fetchBizLocationData(this.mfId),
      fetchReadPointData(this.mfId),
      fetchProductData(this.mfId),
    ]);
    this.bizLocationList = bizList;
    this.readPointList   = readList;
    this.productList = prdList;
    
    await this.fetchProductEventData();
    this.fetchBoxData();
    this.fetchEventListData();
  },
  methods: {
    async fetchProductEventData() {
      try {
        const response = await api.get(`/opensearch/productList?eventType=ObjectEvent&bizStep=inspecting&mfId=${this.mfId}`);

        const result = response.data.result;
        this.eventEpcList = result.productList;

        this.combineLists();
      } catch (error) {
        console.error("정보 불러오기 실패:", error);
      }
    },
    combineLists() {
      this.combinedList = this.eventEpcList.map(urn => {
        const baseUrn = urn.split('.').slice(0, -1).join('.');
        const matchedProduct = this.productList.find(rm => this.gtinToGtinUri(rm.gtin) === baseUrn);
        return {
          name: matchedProduct ? matchedProduct.name : "알 수 없음",
          urn: urn
        };
      });
    },
    async fetchBoxData() {
      try {
        const response = await api.get(`/opensearch/boxList?mfId=${this.mfId}`);
        const result = response.data.result;

        this.boxList = result.boxList;
      } catch (error) {
        console.error("정보 불러오기 실패:", error);
      }
    },
    async submitEvent() {
      this.form.eventTime = this.syncEventTimeFromTemp(this.eventTimeTemp);
      this.showLoading?.('이벤트를 EPCIS에 저장중...');
      try {
        // Vuex 통해 EPCIS 캡처 JSON 생성
        this.$store.dispatch('TestDataJsonPreparator/jsonPreparation', { formData: this.form });
        this.$store.commit(
          'TestDataGeneratorStore/populateTestDataInput',
          JSON.stringify(this.$store.state.TestDataJsonPreparator.testDataInputTemplate)
        );
        await this.$store.dispatch('TestDataGeneratorStore/testdataGenerator');
        const dataResult = JSON.stringify(this.$store.state.TestDataGeneratorStore.testDataOutput, null, 2);

        // EPCIS 캡처
        const cap = await this.captureApi(dataResult);
        if (!cap.success) throw new Error(cap.error || 'EPCIS 캡처 실패');

        // ✅ 공통 유틸 사용 (EPCIS → 블록체인)
        const committedEvent = await pollEpcisEvent(this.crtEventID, {
          timeout: 60000, startInterval: 800, maxInterval: 4000
        });
        
        this.showLoading?.('이벤트를 블록체인에 저장중...');
        await saveBlockChain(this.crtEventID, committedEvent, 60000);

        this.toastSuccess?.("저장 되었습니다.");
        setTimeout(() => this.fetchEventListData(), 2000);
      } catch (e) {
        console.error(e);
        this.toastError?.(e.message || '처리 중 오류가 발생했습니다.');
      } finally {
        this.hideLoading?.();
      }
    },

    // ✅ EPCIS 캡처: AggregationEvent 맞게 값 세팅 + eventID 생성/보관
    async captureApi(dataResult) {
      try {
        const jsonData = JSON.parse(dataResult);
        const event = jsonData.epcisBody.eventList[0];

        // parentID(박스), childEPCs(제품 리스트)
        event.parentID  = this.form.parentID;
        event.childEPCs = this.selectedUrns.map(it => it.urn);
        delete event.epcList;

        // 회사 prefix
        if (this.mfId) {
          event["cbv:extension"] = { ...(event["cbv:extension"] || {}), companyPrefix: this.mfId };
        }

        // eventID 없으면 생성
        if (!event.eventID) {
          const id = (crypto?.randomUUID?.() || (Date.now().toString(36) + Math.random().toString(36).slice(2)));
          this.crtEventID = `urn:uuid:${id}`;
          event.eventID = this.crtEventID;
        } else {
          this.crtEventID = event.eventID;
        }

        const resp = await fetch(`/api/epcisAPI/capture`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(jsonData),
        });
        if (!resp.ok) throw new Error("응답 오류: " + resp.status);

        const text = await resp.text();
        const result = text ? JSON.parse(text) : {};
        return { success: true, data: result };
      } catch (e) {
        console.error('전송 실패:', e);
        return { success: false, error: e.message || e };
      }
    },
    async fetchEventListData() {
      this.loadingEvents = true;
      try {

        const [res] = await Promise.all([
          api.get(`/event/list`, {
            params: { 
              mfId: this.mfId,
              eventType: this.form.eventType,
              bizStep: this.form.businessStep.toLowerCase(),
              disposition: this.form.disposition.toLowerCase()
            }
          }),
          new Promise(r => setTimeout(r, 600))
        ]);

        const result = res.data.result;
        this.recentEventList = result.recentEventList || [];
      } catch (error) {
        console.error("정보 불러오기 실패:", error);
      } finally {
        this.loadingEvents = false;
      }
    },
    
  },
};
</script>


<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.css";
::v-deep .ms-urn .multiselect__option { font-size: 13px; }

/* 리스트 컨테이너: 세로 스크롤 */
.selected-list { height: 505px; overflow-y: auto; }

.sel-item {
  padding: .5rem .25rem;
  border-bottom: 1px solid rgba(0,0,0,.06);
}
.sel-item:last-child { border-bottom: none; }

/* 제품명 라벨 */
.prod-chip {
  display: inline-block;
  font-size: .8rem;
  font-weight: 700;
  padding: .25rem .6rem;
  border-radius: 9999px;
  background: #eef7ff;
  color: #0d6efd; /* 필요시 브랜드 컬러로 변경 */
}

/* URN 한 줄 + 가로 스크롤 */
.urn-line {
  margin-top: .35rem;
  font-size: 0.9rem;
  color: #6c757d;
  white-space: nowrap;
  overflow-x: auto;
}
.urn-line::-webkit-scrollbar { height: 6px; }
.urn-line::-webkit-scrollbar-thumb { background: rgba(0,0,0,.2); border-radius: 3px; }
.urn-line::-webkit-scrollbar-track { background: transparent; }

.empty-state {
  height: 100%;
  display: flex; align-items: center; justify-content: center;
  color: #9aa3ae; font-size: .95rem;
}
</style>